<template>
    <div id="hd">
        <el-tooltip class="item" effect="dark" content="导航菜单" placement="right">
            <div class="sidebar-toggle-box" @click="toggleSidebar">
                <i :class="'iconfont icon-reorder'"></i>
                <a href="/index.html" class="logo"><span>一发科技</span></a>
            </div>
        </el-tooltip>
        <el-dropdown split-button type="primary" class="login-info" @command="handleCommand">
            {{userName}}
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="logout">登出</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>
<script>
    import {loginApi} from "../common/loginApi";

    export default {
        name: "hd",
        props: {
            value: {
                default: true,
                type: Boolean
            }
        },
        data() {
            return {
                userName: '未登录'
            }
        },
        mounted() {
            var that = this
            loginApi.isLogin.call(this, {}, function (res) {
                if (res.success) {
                    var userName = res.result.userName ? res.result.userName : '未登录';
                    that.userName = userName
                    if (res.apiCode === 9002) {
                        if (window.location.pathname !== '/not_past.html') {
                            window.location.href = "/not_past.html"
                        }
                        return;
                    }
                    if (res.apiCode === 9001) {
                        if (window.location.pathname !== '/app_settings.html')
                            window.location.href = "/app_settings.html"
                    }
                } else {
                    if (res.apiCode === 8002) {
                        window.location.href = "/login.html?v=2021072601"
                    }
                }
            })
        },
        methods: {
            toggleSidebar() {
                this.$emit('input', !this.value) // 这儿必须用input 发送数据，发送的数据会被父级v-model=“test”接受到，再被value=test传回来。
            },
            handleCommand(command) {
                if(command === 'logout'){
                    loginApi.logout.call(this,{},function (res) {
                        window.location.href="/login.html?v=2021072601"
                    })
                }
            }
        }
    }
</script>
<style lang="scss">
    #hd {
        width: 100%;

        .logo {
            color: #FF6C60;
            font-size: 21px;
            margin-left: 10px;
            font-weight: 500;
        }

        .login-info {
            float: right;

            button {
                background-color: #fff;
                border-color: #eee;
                color: #aaa;
            }
        }
    }

</style>